import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../global/theme/tokens";
import { useEffect, useState } from "react";
import { numberToString } from "../../special/numberConverter";
import { useConfig } from "../../../api/api";
import MoneyLabel from "../../label/MoneyLabel";

const Sum = ({ sum, cols, collapseModules }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();
  const [columnCount, setColumnCount] = useState(null);
  const [mobileHiddenCount, setMobileHiddenCount] = useState(null);

  useEffect(() => {
    var newColumnCount = 0;
    var newMobileHiddenCount = 0;
    cols.forEach((col) => {
      if (!col.hidden) {
        newColumnCount++;

        if (col.hideOnMobile) newMobileHiddenCount++;
      }
    });
    setMobileHiddenCount(newMobileHiddenCount);
    setColumnCount(newColumnCount);
  }, []);

  return (
    <>
      <SumElement
        collapseModules={collapseModules}
        mobileHiddenCount={mobileHiddenCount}
        colSpan={columnCount}
        sum={sum.netto}
        text="Netto"
        currency={config && config.currency.currencySymbol}
      />

      <SumElement
        collapseModules={collapseModules}
        mobileHiddenCount={mobileHiddenCount}
        colSpan={columnCount}
        sum={sum.tax}
        text="MwSt."
        currency={config && config.currency.currencySymbol}
      />

      <SumElement
        collapseModules={collapseModules}
        mobileHiddenCount={mobileHiddenCount}
        colSpan={columnCount}
        sum={sum.netto + sum.tax}
        text="Brutto"
        currency={config && config.currency.currencySymbol}
      />
    </>
  );
};

const SumElement = ({
  colSpan,
  sum,
  text,
  mobileHiddenCount,
  collapseModules,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const colCorrection = collapseModules ? 1 : 2;

  const colsToAdd = colSpan - colCorrection > 0 ? colSpan - colCorrection : 0;

  return (
    <tr>
      {Array(colsToAdd)
        .fill(null)
        .map((col, index) => (
          <td
            key={index}
            className={`${
              index < mobileHiddenCount ? "hidden md:table-cell" : ""
            }`}
          ></td>
        ))}
      <td>
        <Box className="w-full text-right pb-2">{text}</Box>
      </td>
      <td>
        <Box className="w-full text-right monospace pr-1 pb-2">
          <MoneyLabel money={sum} />
        </Box>
      </td>
    </tr>
  );
};

export default Sum;
